import { render, staticRenderFns } from "./ProjectOrderIndex.vue?vue&type=template&id=00ad319a&"
import script from "./ProjectOrderIndex.vue?vue&type=script&lang=js&"
export * from "./ProjectOrderIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports